/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';
import { ChatToolbarProps } from './types';

const ToolbarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

const ChatToolbar: React.FC<ChatToolbarProps> = ({
  disabled,
  toolbarItems = [],
}) => {
  const messages = useSelector(
    (state: RootState) => state.workflow.currentWorkflow.messages,
  );

  return (
    <ToolbarContainer>
      {toolbarItems.map((item, index) => (
        <React.Fragment key={index}>
          {item({ disabled, messages })}
        </React.Fragment>
      ))}
      <Box sx={{ flex: 1 }} />
    </ToolbarContainer>
  );
};

export default ChatToolbar;
